module.exports = __webpack_public_path__ + "7ebddbc05e61617030fe8457071cb494.svg";